import { Alert } from 'antd';
import React from 'react';
import styled from 'styled-components';

const SearchRowAlertWrapper = styled(Alert)`
  padding: 2px 12px;
  border-width: 2px;
  border-radius: 0;
  min-height: 32px;
`;

export interface SearchRowAlertProps {
  message?: React.ReactNode;
  type?: 'error' | 'success' | 'info' | 'warning' | undefined;
}

/**
 * Messaggio di errore per i campi custom async di ricerca
 */
export function SearchRowAlert(props: SearchRowAlertProps) {
  const { message, type } = props;
  return (
    <SearchRowAlertWrapper message={message} showIcon type={type ?? 'error'} />
  );
}
